<template>
  <div class="container full-width">
    <!-- Start Modal -->
    <!-- Modal -->
    <div class="modal fade" id="confirmationModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <div class="modal-title" style="display: block;">
                <div class="arrow" style="margin-left: 0;"></div>
                <div class="h2-arrow" style="padding: 0;">
                  SOUHAITEZ-VOUS CONFIRMER<br/>LA SUPPRESSION DE CE MEDIA
                </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal" id="messageSuppressionConfirmed">Ok</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="validModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <div class="modal-title" style="display: block;">
                <div class="arrow" style="margin-left: 0;"></div>
                <div class="h2-arrow" style="padding: 0;" id="validModalContent">
                </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Ok</button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Modal -->

    <!-- Header Start -->
    <app-header></app-header>
    <!-- Header End -->

    <!-- div oblique -->
    <side-info :template="name" v-bind:style="[mainPaddingTop]" ref="sideInfo"></side-info>

    <div class="main" v-bind:style="mainPaddingTop">
      <div class="fil-ariane">
          <router-link to="/app/home" class="parent-items">
            Mon espace >
          </router-link>
          <router-link to="/app/creer-un-message" class="parent-items">
            Ajouter un nouveau message >
          </router-link>
          <router-link to="/app/gerer-diffusion" class="parent-items">
            Gérer ma diffusion
          </router-link>
      </div>
      <h1 class="page-title">Choisir mon message</h1>
      <!--  -->
      <div v-bind:style="welcomeMessages['noCreationOnDisplay']">
        <p style="margin-top: calc(100vh / (949 / 10)); font-family: 'Open Sans', Arial; font-size: 14px;">
          Vous n'avez aucun message en cours. Consultez <router-link to="/miscellanous/mentions-legales" style="color:var(--primary-color);">les mentions légales</router-link> avant de diffuser votre message promotionnel ou informatif.
        </p>
      </div>
      <div class="main-content">
        <!-- ////////////////////////////////////////// -->
        <div class="info-box-main">
          <svg class="info-box-icon-main" xmlns="http://www.w3.org/2000/svg" viewBox="8949 -947 14.89 50"><path class="a" d="M30.19,997.365a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,30.19,997.365Zm0,16.541H22.56l.012,3,5.89-.021v27.5H22.556l.006,2.952,7.628.01,7.255.018-.006-2.97-5.519-.01v-27.5c0-2.991.046-2.987-1.73-2.987Z" transform="translate(8926.444 -1944.365)"/></svg>
          <div class="info-text-main">
            Déplacez vos messages vers la caisse sur laquelle<br/>vous souhaitez diffuser l'annonce.
          </div>
        </div>
        <div class="table-display">
          <!-- <div class="editor-holder col-md-12 table-row"> -->
            <div  v-if="userProps && userProps.appData && userProps.appData.medias && userProps.appData.medias.length !== 0" class="strip-wrapper">
              <div id="arrow-left" v-bind:style="arrowLeft" v-on:click="toTheRight" class="table-cell v-align-middle">
                <svg class="black-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="10687 441.84 26.286 50"><path class="a" d="M43.143,6.285a.945.945,0,0,1-.279.67L19.811,30.009,42.85,53.046a.947.947,0,0,1,0,1.342l-.336.334a.945.945,0,0,1-1.34,0L17.133,30.68a.939.939,0,0,1-.2-1.045.974.974,0,0,1,.1-.148.908.908,0,0,1,.1-.146l0,0c.005-.005.007-.012.012-.018L41.188,5.279a.947.947,0,0,1,1.342,0l.334.334a.949.949,0,0,1,.279.672Z" transform="translate(10670.143 436.84)"/></svg>
              </div>
              <div class="table-cell media-library-holder">
                <div class="strip-holder">
                <!-- start vignette-holder -->
                  <div class="strip" v-bind:style="stripLeft">
                    <div v-for="(media, index) in userProps.appData.medias" class="vignette-holder" v-if="typeof media.media_content.diffusionIndex !== 'number'" v-on:mouseenter.prevent="showVignetteTooltip(media.media_id)" v-on:mouseleave.prevent="hideVignetteTooltip(media.media_id)">
                      <div class="bmtv-tooltip-inner bmtv-tooltip-vignette" v-show="tooltipVignette[media.media_id]">
                          <div class="bmtv-tooltip-inner-item" v-on:click="zoom(media.media_id)">
                            Zoomer
                            <div class="glyphicon glyphicon-zoom-in context-ico"></div>
                          </div>
                          <div class="bmtv-tooltip-inner-item" v-on:click="reuse(media.media_id)">
                            Réutiliser
                            <div class="glyphicon glyphicon-retweet context-ico"></div>
                          </div>
                          <div class="bmtv-tooltip-inner-item" :data-media-id="media.media_id" v-on:click="suppress(media.media_id)">
                            <input type="hidden" id="mediaIdSuppression" name="mediaIdSuppression"/>
                            Supprimer
                            <div class="glyphicon glyphicon-trash context-ico"></div>
                          </div>
                          <div class="bmtv-tooltip-arrow"></div>
                      </div>
                      <div class="vignette-diffusion has-tooltip" v-bind:id="'strip-' + media.media_id" draggable="true" v-on:dragstart="dragStart" v-on:dragend="dragEnd" v-bind:style="{ backgroundImage: 'url(' + media.media_content.message + ')', backgroundSize: 'cover'}" ></div>
                  </div>
                </div>
                <!-- end vignette-holder -->
                </div>
              </div>
            <div id="arrow-right" v-bind:style="arrowRight" v-on:click="toTheLeft" class="table-cell v-align-middle">
              <svg class="black-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="11589.272 441.84 26.291 50"><path class="a" d="M16.858,6.285a.945.945,0,0,0,.279.67L40.195,30.009,17.151,53.046a.947.947,0,0,0,0,1.342l.336.334a.945.945,0,0,0,1.34,0L42.873,30.68a.939.939,0,0,0,.2-1.045.974.974,0,0,0-.1-.148.908.908,0,0,0-.1-.146l0,0c-.005-.005-.006-.012-.012-.018L18.813,5.279a.947.947,0,0,0-1.342,0l-.334.334a.949.949,0,0,0-.279.672Z" transform="translate(11572.415 436.84)"/></svg>
            </div>
          </div>
        </div>

        <div id="visualisation-holder">
          <!-- start display options according to user medias -->
          <!-- option 1 -->
          <div id="no-creation-yet" v-bind:style="welcomeMessages['noCreationYetDisplay']">
            <p style="margin-bottom: calc(100vh / (949 / 40));">
              Vous vous connectez pour la première fois ?<br/>Consultez <router-link to="/miscellanous/conseils-pratiques">nos conseils pratiques</router-link> avant de créer votre premier message promotionnel ou informatif.
            </p>
            <router-link to="/app/creer-un-message" id="mentions-legales" class="btn btn-default btn-side-info" style="margin-top: calc(100vw / (1920 / 40));">
              CRÉER MON PREMIER MESSAGE
            </router-link>
          </div>
          <!-- option 2 -->
          <div id="no-creation-on" v-bind:style="welcomeMessages['noCreationOnDisplay']">
            <current-diffusion v-bind:slotLimit="slotLimit" v-bind:editEnabled="editEnabled" v-bind:userProps="userProps" v-bind:overDropZone="overDropZone" v-bind:terminalMediaArr="terminalMediaArr" v-bind:currentDraggedImg="currentDraggedImg"></current-diffusion>
            <!--
              <button id="set-message" class="btn btn-default btn-side-info" v-on:click="saveMessages(true)">
                VALIDER
              </button>
            -->
          </div>
          <!-- option 3 -->
          <div id="current-creations" v-bind:style="welcomeMessages['currentCreationsDisplay']">
            <current-diffusion v-bind:slotLimit="slotLimit" v-bind:editEnabled="editEnabled" v-bind:userProps="userProps" v-bind:overDropZone="overDropZone" v-bind:terminalMediaArr="terminalMediaArr" v-bind:currentDraggedImg="currentDraggedImg"></current-diffusion>
            <!--
              <button id="set-message" class="btn btn-default btn-side-info" v-on:click="saveMessages(true)">
                VALIDER
              </button>
            -->
          </div>
          <!-- end display options according to user medias -->
        </div>
        <div class="hr"></div>
        <!-- ////////////////////////////////////////// -->
      </div>
    </div>
    <!-- ////////////// Footer Start ////////////// -->
    <app-footer></app-footer>
    <!-- ////////////// Footer End ////////////// -->
    <!-- Button trigger modal -->
    <button id="modalButton" type="button" class="btn btn-primary btn-lg" data-toggle="modal" data-target="#confirmationModal" style="visibility: hidden;">
      Launch modal
    </button>
    <button id="modal2Button" type="button" class="btn btn-primary btn-lg" data-toggle="modal" data-target="#validModal" style="visibility: hidden;">
      Launch modal
    </button>
    <div id="tempHolder" style="visibility: hidden;"></div>
  </div>
</template>

<script>
  const TWEEN = require('@tweenjs/tween.js')
  import CurrentDiffusion from '@/components/CurrentDiffusion'
  // TODO --> check if line below in necessary to keep
  const AppModules = require('annonces-app-modules')(process.env.APP_NAME, process.env.NODE_ENV)
  import setPaddingTop from '@/common/lib/setPaddingTop'
  import Header from '@/components/Header'
  import SideInfo from '@/components/SideInfo'
  import Footer from '@/components/Footer'
  export default {
    data () {
      return {
        name: 'GererDiffusion',
        user: AppModules.getUser(),
        userProps: {},
        pageMainTitle: {
          boulangerie: 'Choisir mes messages',
          tabac: 'Choisir mon message'
        },
        mainPaddingTop: {
          paddingTop: '0'
        },
        sideInfoBackground: {
          backgroundImage: 'none'
        },
        inputTitle: 'Votre Titre',
        store: AppModules.Store,
        tweenIncrement: 0,
        stripLeft: {
          left: '0'
        },
        arrowLeft: {
          fill: 'transparent'
        },
        arrowRight: {
          fill: 'transparent'
        },
        welcomeMessages: {
          currentDiffusionTitle: {
            display: 'none'
          },
          noCreationYetDisplay: {
            display: 'none'
          },
          noCreationOnDisplay: {
            display: 'none'
          },
          currentCreationsDisplay: {
            display: 'none'
          }
        },
        slotLimit: 0,
        editEnabled: 1,
        overDropZone: false,
        terminalMediaArr: [],
        currentDraggedImg: '',
        parentMethods: this.methods,
        mediaToSuppress: null,
        definitions: AppModules.MessageDefinitions[process.env.APP_NAME],
        // tableau de propriétés pour l'affichage de la tooltip sur les vignettes
        tooltipVignette: []
      }
    },
    components: {
      'app-header': Header,
      'side-info': SideInfo,
      'app-footer': Footer,
      'current-diffusion': CurrentDiffusion
    },
    mounted: function () {
      var self = this
      //
      return this.user.getProperties(function (err, userProps) {
        if (err) {
          console.log(err)
        }
        //
        self.userProps = userProps
        // initialiser le tableau de propriétés pour l'affichage de la tooltip sur les vignettes
        for (let m of userProps.appData.medias) {
          self.tooltipVignette[m.media_id] = false
        }
        //
        self.adjustPaddingTop()
        self.switchWelcomeMessage(false)
        //
        window.removeEventListener('resize', self.adjustPaddingTop, false)
        window.addEventListener('resize', self.adjustPaddingTop, false)
        //
        if (self.userProps && self.userProps.appData && self.userProps.appData.medias && self.userProps.appData.medias.length > 4) {
          self.arrowLeft.fill = 'var(--grey-primary-color)'
          self.arrowRight.fill = 'var(--grey-primary-color)'
        }
        //
        function animate (time) {
          requestAnimationFrame(animate)
          TWEEN.update(time)
        }
        requestAnimationFrame(animate)
        //
        let messageSuppressionConfirmed = document.querySelector('#messageSuppressionConfirmed')
        messageSuppressionConfirmed.addEventListener('click', function (e) {
          self.suppressMedia()
        })
      })
    },
    methods: {
      // méthode appelée sur le mouseenter d'une vignette
      // pour afficher la tooltip
      showVignetteTooltip: function (id) {
        this.$set(this.tooltipVignette, id, true)
      },
      // méthode appelée sur le mouseleave d'une vignette
      // pour cacher la tooltip
      hideVignetteTooltip: function (id) {
        this.$set(this.tooltipVignette, id, false)
      },

      getMedia: function (mediaId) {
        let media = {}
        if (this.userProps && this.userProps.appData && this.userProps.appData.medias && this.userProps.appData.medias.length > 0) {
          media = this.userProps.appData.medias.find(function (item) {
            return item.media_id === parseInt(mediaId)
          })
        }
        return media
      },
      setCurrentDraggedImg: function (mediaId) {
        if (this.userProps && this.userProps.appData && this.userProps.appData.medias && this.userProps.appData.medias.length > 0) {
          let currentDraggedMedia = this.userProps.appData.medias.find(function (item) {
            return item.media_id === mediaId
          })
          if (currentDraggedMedia) {
            this.currentDraggedImg = currentDraggedMedia.media_content.message
          }
        }
      },
      findTerminalMedia: function (medias, callback) {
        if (medias.length > 0) {
          this.terminalMediaArr = []
          for (let i = 0; i < this.slotLimit; ++i) {
            let media = medias.find((item) => {
              return item.media_content.diffusionIndex === i
            })
            //
            if (media) {
              this.terminalMediaArr.push(media)
            } else {
              this.terminalMediaArr.push(null)
            }
            //
            if (i >= (this.slotLimit - 1)) {
              return callback()
            }
          }
        }
      },
      dragStart: function (e) {
        e.dataTransfer.effectAllowed = 'move'
        e.dataTransfer.setData('text/plain', e.target.id)
        this.setCurrentDraggedImg(parseInt(e.target.id.split('-')[1]))
      },
      dragEnd: function (e) {
        if (this.overDropZone) {
          this.switchWelcomeMessage(true)
          this.overDropZone = false
        }
      },
      tween: function (oldStyleLeft, newStyleLeft) {
        var self = this
        //
        new TWEEN.Tween({x: oldStyleLeft, y: 0})
        .to({x: newStyleLeft}, 1000)
        .easing(TWEEN.Easing.Quadratic.Out)
        .onUpdate(function (object) {
          self.stripLeft.left = Math.round(object.x) + 'px'
        })
        .start()
      },
      toTheLeft: function () {
        let strip = document.querySelector('.strip')
        let vignettes = strip.querySelectorAll('.vignette-diffusion')
        if (vignettes.length > 4 && (vignettes.length - 4) > (this.tweenIncrement * -1)) {
          //
          let vignetteHolders = strip.querySelectorAll('.vignette-holder')
          if (vignetteHolders.length) {
            let vignetteHolderWith = window.getComputedStyle(vignetteHolders[0]).getPropertyValue('width')
            let oldStyleLeft = (parseInt(vignetteHolderWith) * this.tweenIncrement)
            --this.tweenIncrement
            let newStyleLeft = (parseInt(vignetteHolderWith) * this.tweenIncrement)
            this.tween(oldStyleLeft, newStyleLeft)
          }
        }
      },
      toTheRight: function () {
        let strip = document.querySelector('.strip')
        let vignettes = strip.querySelectorAll('.vignette-diffusion')
        if (vignettes.length > 4 && this.tweenIncrement < 0) {
          //
          let vignetteHolders = strip.querySelectorAll('.vignette-holder')
          if (vignetteHolders.length) {
            let vignetteHolderWith = window.getComputedStyle(vignetteHolders[0]).getPropertyValue('width')
            let oldStyleLeft = (parseInt(vignetteHolderWith) * this.tweenIncrement)
            ++this.tweenIncrement
            let newStyleLeft = (parseInt(vignetteHolderWith) * this.tweenIncrement)
            this.tween(oldStyleLeft, newStyleLeft)
          }
        }
      },
      offsetStrip: function (medias) {
        let self = this
        let stripMediaArr = []
        let vignetteHolderWith
        let vignetteHolders
        let stripTotalWidth
        //
        function lastItemAdjustment (stripMediaArr) {
          if (stripMediaArr.length > 4 && ((stripMediaArr.length + self.tweenIncrement) < 4)) {
            self.tweenIncrement = self.tweenIncrement + (medias.length - stripMediaArr.length)
            console.log(`self.tweenIncrement : ${self.tweenIncrement}`)
          }
          return self.tweenIncrement
        }
        //
        medias.sort(function (a, b) {
          if (a.media_id < b.media_id) {
            return 1
          }
          if (a.media_id > b.media_id) {
            return -1
          }
          return 0
        })
        console.log('////////////////////////////////////////////////// sorted medias')
        console.log(medias)
        vignetteHolders = document.querySelectorAll('.vignette-holder')
        //
        stripMediaArr = medias.filter(item => {
          return (typeof item.media_content.diffusionIndex !== 'number')
        })
        //
        vignetteHolderWith = (stripMediaArr.length) ? window.getComputedStyle(vignetteHolders[0]).getPropertyValue('width') : 0
        //
        if (stripMediaArr.length > 4) {
          self.stripLeft.left = (lastItemAdjustment(stripMediaArr) * parseInt(vignetteHolderWith)) + 'px'
          stripTotalWidth = (stripMediaArr.length * parseInt(vignetteHolderWith))
          console.log(stripMediaArr.length, parseInt(vignetteHolderWith), stripTotalWidth)
        } else {
          let stripHolder = document.querySelectorAll('.strip-holder')[0]
          let stripHolderWith = window.getComputedStyle(stripHolder).getPropertyValue('width')
          self.stripLeft.left = ((parseInt(stripHolderWith) / 2) - ((parseInt(vignetteHolderWith) * stripMediaArr.length) / 2)) + 'px'
        }
      },
      switchWelcomeMessage: function (updateWithLocalMedia) {
        var self = this
        //
        function resetState () {
          for (var state in self.welcomeMessages) {
            self.welcomeMessages[state] = {display: 'none'}
          }
        }
        //
        function updateDisplay (medias) {
          if (medias.length === 0) {
            resetState()
            self.welcomeMessages['noCreationYetDisplay'] = {display: 'block'}
            return
          }
          // - - - - - - - - - - - - - - - -
          resetState()
          self.welcomeMessages['currentCreationsDisplay'] = {display: 'block'}
          self.welcomeMessages['currentDiffusionTitle'] = {display: 'inline'}
          self.offsetStrip(medias)
          return
        }
        // - - - - - - - - - - - - - - - -
        if (updateWithLocalMedia && this.userProps && this.userProps.appData && this.userProps.appData.medias && this.userProps.appData.medias.length > 0) {
          updateDisplay(this.userProps.appData.medias)
          return this.findTerminalMedia(this.userProps.appData.medias, err => {
            if (err) {
              console.error(err)
            }
            //
            return
          })
        }
        // - - - - - - - - - - - - - - - -
        this.user.showCurrentMedia((err, medias, slotLimit) => {
          //
          this.slotLimit = slotLimit
          //
          if (err) {
            console.log(err)
            return
          }
          // - - - - - - - - - - - - - - - -
          updateDisplay(medias, slotLimit)
          return this.findTerminalMedia(medias, err => {
            if (err) {
              console.error(err)
            }
            //
            return this.offsetStrip(medias)
          })
        })
      },
      suppressMedia: function () {
        let self = this
        if (this.mediaToSuppress || typeof this.mediaToSuppress === 'object') {
          return this.user.suppressMedia(this.mediaToSuppress, this.$router, (err, status, userProps) => {
            if (err) {
              console.error(err)
            }
            //
            self.userProps = userProps
            self.switchWelcomeMessage(true)
          })
        }
      },
      saveMessages: function (redirectURI) {
        this.user.saveMessages(redirectURI, this.$router, this.userProps)
      },
      confirmMessageSuppression: function (media) {
        let modalButton = document.querySelector('#modalButton')
        this.mediaToSuppress = media
        return modalButton.click()
      },
      confirmMessageValidation: function (media) {
        let modalButton = document.querySelector('#modal2Button')
        this.mediaToSuppress = media
        return modalButton.click()
      },
      adjustPaddingTop: function () {
        var self = this
        setTimeout(function () {
          if (self.userProps && self.userProps.appData && self.userProps.appData.medias && self.userProps.appData.medias.length > 0) {
            self.offsetStrip(self.userProps.appData.medias)
          }
        }, 0)
        setPaddingTop((err, paddingTop) => {
          if (err) {
            console.log(err)
          }
          this.mainPaddingTop.paddingTop = paddingTop + 'px'
        })
      },
      // méthode appelée pour la fonction zoom de la tooltip des vignettes
      zoom: function (mediaId) {
        let currentMedia = this.getMedia(mediaId)
        //
        let target = document.querySelector('#app')
        let backdrop = document.createElement('DIV')
        let messageMediaImg = document.createElement('IMG')
        backdrop.setAttribute('id', 'backdrop')
        messageMediaImg.setAttribute('id', 'message-media-img')
        target.style.zIndex = '200'
        target.style.position = 'fixed'
        target.appendChild(backdrop)
        target.appendChild(messageMediaImg)
        let elementBackdrop = document.querySelector('#backdrop')
        let elementMessageMediaImg = document.querySelector('#message-media-img')
        //
        elementBackdrop.style.backgroundColor = 'var(--grey-seventh-color)'
        elementBackdrop.style.width = '100%'
        elementBackdrop.style.height = '100%'
        elementBackdrop.style.position = 'fixed'
        elementBackdrop.style.top = '0'
        elementBackdrop.style.left = '0'
        elementBackdrop.style.zIndex = '1999999998'
        elementBackdrop.style.opacity = '0.5'
        //
        elementMessageMediaImg.style.width = 'calc(100vh / (1080 / 1024))'
        elementMessageMediaImg.style.position = 'fixed'
        elementMessageMediaImg.style.top = 'calc((100vh / 2) - ((100vh / (1080 / 668)) / 2)'
        elementMessageMediaImg.style.left = 'calc((100vw / 2) - ((100vh / (1080 / 1024)) / 2)'
        elementMessageMediaImg.style.zIndex = '1999999999'
        elementMessageMediaImg.style.opacity = '1'
        elementMessageMediaImg.src = currentMedia.media_content.message
        //
        let closeImg = document.createElement('span')
        closeImg.setAttribute('id', 'closeImg')
        elementBackdrop.appendChild(closeImg)
        document.getElementById('closeImg').innerHTML = 'x'
        closeImg.style.marginTop = '15px'
        closeImg.style.marginRight = '15px'
        closeImg.style.float = 'right'
        closeImg.style.cursor = 'pointer'
        closeImg.style.fontWeight = 'bold'
        closeImg.style.fontSize = '25px'
        closeImg.style.color = 'var(--grey-third-color)'
        closeImg.style.lineHeight = '27px'
        closeImg.style.width = '35px'
        closeImg.style.height = '35px'
        closeImg.style.border = '3px solid'
        closeImg.style.borderRadius = '50%'
        closeImg.style.verticalAlign = 'middle'
        //
        elementBackdrop.addEventListener('click', function (e) {
          target.removeChild(backdrop)
          target.removeChild(messageMediaImg)
          target.removeAttribute('style')
          target.removeAttribute(closeImg)
        }, false)
      },
      // méthode appelée pour la fonction réutiliser de la tooltip des vignettes
      reuse: function (mediaId) {
        let self = this
        let currentMedia = this.getMedia(mediaId)
        let messagedefinition = this.definitions.templates.find(function (item) {
          return item.templateId === currentMedia.media_content.type_annonce
        })
        let Message = AppModules.getMessage(messagedefinition, null)
        //
        console.log('messagedefinition.imageInput.shouldCheck')
        console.log(messagedefinition)
        if (currentMedia.media_content.titre) {
          messagedefinition.fullStyle.title.html = currentMedia.media_content.titre
        }
        if (currentMedia.media_content.texte) {
          console.log('//////////////////////\n-currentMedia.media_content.texte')
          console.log(currentMedia.media_content.texte)
          messagedefinition.fullStyle.mainText.html = currentMedia.media_content.texte
          messagedefinition.reducedStyle.mainText.html = Message.reuseMainTextHtml(currentMedia.media_content.texte)
          console.log('//////////////////////\n-messagedefinition.reducedStyle.mainText.html')
          console.log(messagedefinition.reducedStyle.mainText.html)
        }
        if (currentMedia.media_content.visuel) {
          Message.getBase64Media(this.userProps, currentMedia, function (err, base64Media) {
            if (err) {
              console.log(err)
            }
            console.log('////////////////////////////////\n-updatedMedia')
            if (base64Media) {
              console.log(base64Media)
              messagedefinition.fullStyle.imageInput.content = base64Media
              messagedefinition.reducedStyle.imageInputPlaceholderHTML = '<br/>'
            }
            AppModules.clearMessages()
            Message.storeReuseableMessage(self.$router)
          })
        } else if (!messagedefinition.fullStyle.imageInput.shouldCheck) {
          AppModules.clearMessages()
          Message.storeReuseableMessage(self.$router)
        }
      },
      // méthode appelée pour la fonction supprimer de la tooltip des vignettes
      suppress: function (mediaId) {
        let currentMedia = this.getMedia(mediaId)
        console.log(`currentMedia-1 ${JSON.stringify(currentMedia, null, 4)}`)
        return this.confirmMessageSuppression(currentMedia)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  @media (max-width: 1366px) {

    .vignette-holder {
      vertical-align: bottom;
      padding: calc(85vh / (637 / 15)) calc(85vh / (637 / 8));
      display: table-cell;
      height: 245.32px;
    }

    .vignette-diffusion {
      width: calc(85vh / (637 / 165));
      height: calc(85vh / (637 / 108));
      border: 1px solid var(--primary-color);
      box-sizing: border-box;
      border-radius: 10px;
    }

    .template-label {
      font-family: 'Open Sans', Arial;
      color: var(--primary-color);
      font-weight: 400;
      font-size: calc(85vh / (637 / 16));
      display: block;
      margin-top: calc(85vh / (637 / 7));
    }

    .table-cell {
      display: table-cell;
      height: calc((85vh / (637 / 118)) + (85vh / (637 / 30)));
    }

    .media-library-holder {
      width: calc(((85vh / (637 / 165)) * 4) + ((85vh / (637 / 8)) * 4));
      position: relative;
      display: table;
    }

    .strip-wrapper {
      display: inherit;
      margin-top: -7vh;
    }

    .strip-holder {
      position: relative;
      overflow: hidden;
      width: calc((85vh / (637 / 165) * 4) + ((85vh / (637 / 8) * 2) * 4));
      /* display: table-row; */
    }

    .table-display {
      display: table;
      width: calc((85vh / (949 / 27) * 2) + ((85vh / (637 / 165) * 4) + ((85vh / (637 / 8) * 2) * 4)) + 2px);
      margin: auto;
      padding-bottom: 20px;
    }

  }

  @media (min-width: 1367px) {

    .main-content {
      width: calc(100vw * 0.7);
    }

    .vignette-holder {
      vertical-align: bottom;
      padding: 20px 15px;
      display: table-cell;
      height: 232.45px;
    }

    .vignette-diffusion {
      width: 180px;
      height: 118px;
      border: 1px solid var(--primary-color);
      box-sizing: border-box;
      border-radius: 10px;
    }

    .template-label {
      font-family: 'Open Sans', Arial;
      color: var(--primary-color);
      font-weight: 400;
      font-size: 16px;
      display: block;
      margin-top: 7px;
    }

    .table-cell {
      display: table-cell;
      height: calc(118px + 40px);
    }

    .media-library-holder {
      width: calc(210px * 4);
      position: relative;
    }


    .strip-wrapper {
      display: inherit;
      margin-top: -7vh;
    }

    .strip-holder {
      /* position: absolute; */
      width: calc((180px * 4) + (30px * 4));
      overflow: hidden;
      /* display: table-row; */
    }

    .table-display {
      display: table;
      width: calc((85vh / (949 / 27) * 2) + (210px * 4) + 2px);
      margin: auto;
      padding-bottom: 20px;
    }

  }

  .table-row {
    display: table-row;
  }

  .v-align-middle {
    vertical-align: middle;
  }

  .black-arrow {
    stroke: none;
    height: calc(85vh / (949 / 50));
    width: calc(85vh / (949 / 27));
    cursor: pointer;
    margin-top: 77px;
  }

  .strip {
    position: relative;
  }

  p {
    text-align: justify;
    padding-bottom: 25px;
  }

  .vignette-selected {
    border: 10px solid  var(--primary-color);
    box-sizing: border-box;
  }

  .media-vignette-holder-selected, .media-vignette-holder-selected > img {
    width: 550px;
    display: block;
  }

  #visualisation-holder {
    /*position: relative;*/
    /* width: 100%; */
    /*width: 512px;*/
    /*height: 334px;*/
    margin: 0 auto;
  }

  #current-creations{
    padding-top:0;
  }

  .fade-enter-active, .fade-leave-active {
    /*transition: <property> <duration> <timing-function> <delay>;*/
    transition: all 0.8s ease;
    visibility: visible;
    opacity: 1;
    position: absolute;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
    visibility: hidden;
  }

  #compose-message-button {
    cursor: pointer;
  }

  /* tooltip */

  .context-ico {
    float: right;
    font-size: 14px;
    font-weight: normal;
  }

  .bmtv-tooltip.top .bmtv-tooltip-arrow {
    bottom: 0px;
    left: 50%;
    margin-left: -5px;
    border-width: 5px 5px 0;
    border-top-color: var(--grey-eighth-color);
  }

  .bmtv-tooltip-vignette .bmtv-tooltip-arrow {
    border-width: 5px 5px 0;
    border-top-color: var(--grey-eighth-color);
    margin-left: 60px;
    border-width: 5px 5px 0;
    border-top-color: var(--grey-eighth-color);
  }

  .bmtv-tooltip-inner {
    color: var(--secondary-color);
    text-align: center;
    background-color: var(--grey-eighth-color);
    border-radius: 4px;
    box-shadow: 0 2px 5px 0.2px rgba(0, 0, 0, 0.25);
    overflow: visible !important;
  }

  .bmtv-tooltip-arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    box-sizing: border-box;
  }

  .bmtv-tooltip.top {
    padding: 5px 0;
    position: absolute;
  }

  .bmtv-tooltip {
    position: absolute;
    z-index: 1070;
    display: block;
    font-family: 'Open Sans', Arial;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    word-wrap: normal;
    white-space: normal;
    line-break: auto;
    width: 140px;
    visibility: visible;
  }

  .bmtv-tooltip-vignette {
    display: block;
    font-family: 'Open Sans', Arial;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    word-wrap: normal;
    white-space: normal;
    line-break: auto;
    z-index: 1;
    position: relative;
    margin-bottom: 5px;
    width: 150px;
}

@media (max-width: 1366px) {
    .bmtv-tooltip-vignette {
        left: calc(((85vh / (637 / 165)) - 150px)/2);
    }
  }
  @media (min-width: 1367px) {
    .bmtv-tooltip-vignette {
        left: 15px;
    }
  }

  .bmtv-tooltip-inner-item {
    letter-spacing: 0.4px;
    padding: 3px 8px;
    text-align: left;
    font-weight: normal;
    background-color: none;
    cursor: pointer;
    overflow: visible;
    visibility: visible;
  }

  .bmtv-tooltip-inner-item:hover {
    letter-spacing: 0;
    font-weight: bold;
    background-color: var(--grey-third-color);
    visibility: visible;
    overflow: visible;
  }

</style>




// WEBPACK FOOTER //
// GererDiffusion.vue?5d69f4f0